import styled from "styled-components";

interface IProps {
    name: string;
    Icons: any;
}

export default function AmountItems({name, Icons}: IProps) {
    return (
        <Container>
            <LeftSection>
                {Icons}
                <Title>{name}</Title>
            </LeftSection>
            <Amount>256</Amount>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    gap: 8px;
    
    padding: 4px;

    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 16px;
`;

const LeftSection = styled.div`
    display: flex;
    gap: 5px;
    color: ${(props) => props.theme.colors.gray.gray_200};
    
    svg{
        color: ${(props) => props.theme.colors.primary};
    }
    `;

const Title = styled.p``;

const Amount = styled.p`
`;